import {
  pollCartV2Begin,
  pollCartV2Failure,
  pollCartV2Success
} from "@app/modules/checkout/store/v2/slices/cart";
import type { NapiClient } from "@app/services/api";
import { Transaction } from "@app/tracking/error-tracking";

import type { Dispatch } from "redux";

export async function pollCart(
  dispatch: Dispatch,
  api: NapiClient,
  cart_id: string
) {
  dispatch(pollCartV2Begin());
  try {
    const response = await api.pollCartV2(cart_id);
    dispatch(pollCartV2Success(response!));
    return response;
  } catch (error) {
    error.transaction = Transaction.POLL_CART_V2;
    dispatch(pollCartV2Failure(error));
  }
}
